import {
  EMPLOYEE_PIN_LIST_OUTLETS_EMPLOYEES_REQUEST,
  EMPLOYEE_PIN_ON_SUBMIT_FORM,
  EMPLOYEE_PIN_PAGE_REQUEST,
  EMPLOYEE_PIN_PIN_REQUEST,
  SUBMITTING_GET_OUTLETS_EMPLOYEES,
  SUBMITTING_GET_PERMISSIONS,
} from 'actions/employees/pin/constants';
import * as actNotif from 'actions/notifications';
import { hideProgressBar, showProgressBar } from 'actions';
import { initialize } from 'redux-form';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  listOutletsEmployeesRequest,
  pinRequest,
  setAllowedFields,
  setOutletsEmployees,
  setSaveAppPermissionModal,
  setSubmitting,
  showSaveAppPermissionModal,
} from 'actions/employees/pin';
import * as apiSetting from 'api/permissions/settings';
import sortBy from 'lodash/sortBy';
import * as clevertapEmployeesPin from 'clevertap/employees/pin';
import _ from 'lodash';
import * as apiEmployees from 'api/employees';
import isFeatureEnabled from 'selectors/isFeatureEnabled';

const convertToPinFieldValues = pinSettings => {
  const fields = {};
  pinSettings.forEach(ps => {
    fields[ps.id] = ps.pin_required;
  });
  return fields;
};

const getPinRequestObject = pinSettings => {
  const fields = [];
  Object.keys(pinSettings).forEach(function(key) {
    const data = {
      permission_id: key,
      pin_required: pinSettings[key],
    };
    fields.push({
      ...data,
    });
  });
  return fields;
};

/**
 * @param permissions current user permissions
 */
export function* managePermissions({ permissions }) {
  const allowedFields = [];
  permissions = _.sortBy(permissions, 'priority_rank');
  permissions.forEach(p => {
    const data = {
      label: p.sub_menu_name,
      disabled: false,
      name: p.id,
      description: p.description,
      order: p.priorty_rank,
    };
    allowedFields.push({
      ...data,
    });
  });
  const sortedFields = sortBy(allowedFields, ['order']);
  yield put(setAllowedFields({ allowedFields: sortedFields }));
}

export function* pageRequestFlow(request) {
  const {
    payload: { user },
  } = request;

  const pinAccessImprovement = yield select(
    isFeatureEnabled,
    'pin-access-improvement'
  );

  yield put(pinRequest({ user }));

  if (pinAccessImprovement) {
    yield call(listOutletsEmployeesRequestFlow, listOutletsEmployeesRequest());
  }
}

export function* pinRequestFlow() {
  try {
    yield put(showProgressBar());
    yield put(setSubmitting({ submitting: SUBMITTING_GET_PERMISSIONS }));
    const responsePin = yield call(apiSetting.getPin, { params: {} });
    const values = convertToPinFieldValues(responsePin.data.pin_settings);
    yield call(managePermissions, {
      permissions: responsePin.data.pin_settings,
    });
    yield put(initialize('pin', { ...values }));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(setSubmitting({ submitting: null }));
    yield put(hideProgressBar());
  }
}

export function* onSubmitFormFlow(request) {
  const {
    payload: { values },
  } = request;

  let hasPinEnabled = false;
  const pinRequestObject = getPinRequestObject(values);
  Object.values(values).forEach(v => {
    hasPinEnabled = hasPinEnabled || v;
  });
  try {
    yield put(showProgressBar());
    const response = yield call(apiSetting.putPin, {
      data: pinRequestObject,
      params: {},
    });
    yield put(initialize('pin', { ...values }));
    yield put(actNotif.success('Permission is successfully updated'));
    clevertapEmployeesPin.savePin({ pinSettings: response.data.pin_settings });
  } catch (error) {
    if (error.data && error.data.error && error.data.error.code === 10) {
      yield put(
        setSaveAppPermissionModal({ message: error.data.error.user_message })
      );
      yield put(showSaveAppPermissionModal());
    } else {
      yield put(actNotif.error(error.message));
    }
  } finally {
    yield put(hideProgressBar());
  }
}

export function* listOutletsEmployeesRequestFlow() {
  try {
    yield put(showProgressBar());
    yield put(setSubmitting({ submitting: SUBMITTING_GET_OUTLETS_EMPLOYEES }));
    const response = yield call(apiEmployees.getOutletsEmployees);
    yield put(setOutletsEmployees({ outletsEmployees: response.data.outlets }));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(setSubmitting({ submitting: null }));
    yield put(hideProgressBar());
  }
}

export default function* saga() {
  const pinAccessImprovement = yield select(
    isFeatureEnabled,
    'pin-access-improvement'
  );

  yield takeLatest(EMPLOYEE_PIN_PAGE_REQUEST, pageRequestFlow);
  yield takeLatest(EMPLOYEE_PIN_ON_SUBMIT_FORM, onSubmitFormFlow);
  yield takeLatest(EMPLOYEE_PIN_PIN_REQUEST, pinRequestFlow);

  if (pinAccessImprovement) {
    yield takeLatest(
      EMPLOYEE_PIN_LIST_OUTLETS_EMPLOYEES_REQUEST,
      listOutletsEmployeesRequestFlow
    );
  }
}
